import { render, staticRenderFns } from "./CourseSelectView.vue?vue&type=template&id=1185ef62"
import script from "./CourseSelectView.vue?vue&type=script&lang=js"
export * from "./CourseSelectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports